import { render, staticRenderFns } from "./taotiziyuan.vue?vue&type=template&id=90440372&scoped=true"
import script from "./taotiziyuan.vue?vue&type=script&lang=js"
export * from "./taotiziyuan.vue?vue&type=script&lang=js"
import style0 from "./taotiziyuan.vue?vue&type=style&index=0&id=90440372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90440372",
  null
  
)

export default component.exports